import { render, staticRenderFns } from "./LevelBarChart.vue?vue&type=template&id=87fb940c&scoped=true"
import script from "./LevelBarChart.vue?vue&type=script&lang=js"
export * from "./LevelBarChart.vue?vue&type=script&lang=js"
import style0 from "./LevelBarChart.vue?vue&type=style&index=0&id=87fb940c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fb940c",
  null
  
)

export default component.exports